import { Component, OnInit, ViewChild } from '@angular/core';
import { QRApprovalService } from '../qr-approval.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { error, event } from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatTableDataSource } from '@angular/material/table';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { ApprovalDialogComponent } from '../approval-dialog/approval-dialog.component';
import { ExcelService } from 'src/app/totaldvr/excel.service';

@Component({
  selector: 'app-asset-qr-approval-detail',
  templateUrl: './asset-qr-approval-detail.component.html',
  styleUrls: ['./asset-qr-approval-detail.component.scss']
})
export class AssetQrApprovalDetailComponent implements OnInit {
  displayedColumns: string[] = ['fusioncode', 'buildingName', 'minorcategoryname', 'blockno', 'blockname', 'floorno', 'roomtype', 'roomno', 'noofassests', 'status'];
  dataAvailable = true;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  campusdetails: any;
  campusId: any;
  tableDetails: any;
  approvalQRData: any;
  ngOnInit(): void {
    this.selectCampusList();
  }
  constructor(private approval: QRApprovalService, private spinner: NgxSpinnerService, public dialog: NgDialogAnimationService, private excelService: ExcelService) { }

  selectCampusList() {
    this.spinner.show();
    this.approval.getcampusdetail().subscribe(
      {
        next: (res: any) => {
          this.campusdetails = res;
          console.log('CAMPUS', this.campusdetails);
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )
  }


  onSelectedCampus(event: any) {
    this.campusId = event.target.value;
    console.log('this.campusId', this.campusId);
    this.spinner.show();
    this.approval.getTableList(this.campusId).subscribe(
      {
        next: (res: any) => {
          this.tableDetails = res;
          console.log('TableDetails', this.tableDetails);
          this.approvalQRData = new MatTableDataSource(this.tableDetails);
          this.approvalQRData.sort = this.sort;
          this.approvalQRData.paginator = this.paginator;
          this.dataAvailable = true;
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )
  }

  pending(row: any) {
    const dialogRef = this.dialog.open(ApprovalDialogComponent, {
      data: row,
      direction: 'ltr',
      height: '100%',
      width: '40%',
      position: { right: '0px', top: '0px' },
      animation: { to: 'left' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'save') {
        this.spinner.show();
        this.approval.getTableList(this.campusId).subscribe(
          {
            next: (res: any) => {
              this.tableDetails = res;
              console.log('TableDetails', this.tableDetails);
              this.approvalQRData = new MatTableDataSource(this.tableDetails);
              this.approvalQRData.sort = this.sort;
              this.approvalQRData.paginator = this.paginator;
              this.dataAvailable = true;
              this.spinner.hide();
            },
            error: (error: any) => {
              this.spinner.hide();
            }
          }
        );
        console.log('result', result);
      }
    });
  }


  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.approvalQRData.filter = filterValue.trim().toLowerCase();
    console.log('filterValue', filterValue);
  }

  // exportAsXLSX() {
  //   console.log('tableDetails', this.tableDetails);
  //   let fieldsToExtract = ['payrollId', 'userName', 'orcFusionBuildingCode','buildingName','assetPoNo', 'startingNumber','endingNumber','blockNo', 'blockName', 'floorNo', 'roomType', 'roomNo', 'minorCategoryName', 'orgName', 'totalAssets', 'approveStatus'];
  //   let filteredBuildings = this.extractFields(this.tableDetails, fieldsToExtract);
  //   this.excelService.exportAsExcelFile(filteredBuildings, 'tablelist');
  // }

    // Mapping of field names to user-friendly names
    // fieldNameMapping: any = {
    //   payrollId: 'Payroll Id',
    //   userName: 'Name',
    //   orcFusionBuildingCode: 'Fusion Building Code Prod',
    //   buildingName: 'Building Name',
    //   assetPoNo:'Asset Po No',
    //   startingNumber:'Starting Number',
    //   endingNumber:'Ending Number',
    //   blockNo: 'Block No',
    //   blockName: 'Block Name',
    //   floorNo: 'Floor No',
    //   roomType: 'Room Type',
    //   roomNo: 'Room No',
    //   minorCategoryName: 'Category Name',
    //   orgName: 'Org Type',
    //   totalAssets: 'Total Assets',
    //   approveStatus: 'Approve Status',
    // };
  
    // extractFields(objects: any[], fields: string[]): any[] {
    //   return objects.map(obj => {
    //     const newObj: any = {};
    //     fields.forEach(field => {
    //       if (field in obj) {
    //         // Use the mapped name or default to the original field name
    //         const newName = this.fieldNameMapping[field] || field;
    //         newObj[newName] = obj[field];
    //       }
    //     });
    //     return newObj;
    //   });
    // }
    
}
